import React, { useState, useEffect } from 'react';
import { fetchReviews } from '../api';
import ReviewCard from '../components/ReviewCard';
import Loader from '../components/Loader';

export default function SimilarKahanisPage({ review, user, setView }) {
  const [kahanis, setKahanis] = useState([]);
  const [loading, setLoading] = useState(true);

  const company = review?.companyName || review?.company || '';
  const role = review?.role || '';
  const location = review?.location || '';

  useEffect(() => {
    fetchReviews({ limit: 200 })
      .then(data => {
        const all = data.reviews || [];
        const myId = review?._id || review?.id;
        const hasFilters = company || role || location;

        // If no filters at all, show all reviews (excluding own)
        if (!hasFilters) {
          setKahanis(all.filter(r => (r._id || r.id) !== myId));
          return;
        }

        // Filter by any matching field, exclude the submitted review
        const similar = all.filter(r => {
          if ((r._id || r.id) === myId) return false;
          const sameCompany = company && (r.companyName || r.company || '').toLowerCase() === company.toLowerCase();
          const sameRole = role && (r.role || '').toLowerCase() === role.toLowerCase();
          const sameLocation = location && (r.location || '').toLowerCase() === location.toLowerCase();
          return sameCompany || sameRole || sameLocation;
        });

        // Sort: company match (4pts) > role match (2pts) > location match (1pt)
        similar.sort((a, b) => {
          const score = r => {
            let s = 0;
            if (company && (r.companyName || r.company || '').toLowerCase() === company.toLowerCase()) s += 4;
            if (role && (r.role || '').toLowerCase() === role.toLowerCase()) s += 2;
            if (location && (r.location || '').toLowerCase() === location.toLowerCase()) s += 1;
            return s;
          };
          return score(b) - score(a);
        });
        setKahanis(similar);
      })
      .catch(() => setKahanis([]))
      .finally(() => setLoading(false));
  }, [company, role, location, review]);

  return (
    <div style={{ animation: 'fadeUp 0.35s ease-out' }}>
      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
          <button
            onClick={() => setView('my-kahani')}
            style={{
              background: 'none', border: '1px solid var(--border)', borderRadius: 8,
              padding: '4px 10px', fontSize: 12, fontWeight: 600, color: 'var(--text2)',
              cursor: 'pointer', fontFamily: 'var(--sans)',
            }}
          >
            ← Back
          </button>
        </div>
        <h1 style={{ fontFamily: 'var(--display)', fontSize: 22, fontWeight: 900, margin: '0 0 6px', color: 'var(--text)' }}>
          Similar Kahanis
        </h1>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 4 }}>
          {company && <span style={tagStyle}>{company}</span>}
          {role && <span style={tagStyle}>{role}</span>}
          {location && <span style={tagStyle}>{location}</span>}
        </div>
        <p style={{ fontSize: 13, color: 'var(--text3)', margin: 0 }}>
          Interview experiences matching your company, role, or location
        </p>
      </div>

      {loading ? (
        <Loader inline message="Finding similar kahanis…" />
      ) : kahanis.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--text3)', fontSize: 14 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🔍</div>
          <div style={{ fontWeight: 600, marginBottom: 8 }}>No similar kahanis yet</div>
          <div style={{ fontSize: 13 }}>Be the first to share an experience for {company || role || 'this role'}!</div>
        </div>
      ) : (
        <>
          <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 14, fontWeight: 500 }}>
            {kahanis.length} similar kahani{kahanis.length !== 1 ? 's' : ''} found
          </div>
          {kahanis.map((r, i) => (
            <ReviewCard key={r._id || r.id || i} review={r} delay={i * 0.05} currentUser={user} />
          ))}
        </>
      )}
    </div>
  );
}

const tagStyle = {
  fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20,
  background: 'var(--surface2)', border: '1px solid var(--border)',
  color: 'var(--text2)', fontFamily: 'var(--sans)',
};
